import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const ProvideVerbExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Using the Verb "Provide"</h2>
      <p>
        The verb <strong>provide</strong> means to supply something that is needed. It is common in
        technical English, documentation, and requirements, where tools, systems, or professionals
        supply necessary resources.
      </p>

      <div className="example-block">
        <h3><FaLightbulb /> Common patterns</h3>
        <ul>
          <li><strong>Provide something (for someone/something):</strong> <em>The manual provides diagrams for the assembly team.</em></li>
          <li><strong>Provide someone/something with something:</strong> <em>We provide the system with relevant context.</em></li>
          <li><strong>Provide that… (formal):</strong> <em>The policy provides that all code must be reviewed.</em></li>
        </ul>
      </div>

      <h3><FaLightbulb /> Common collocations</h3>
      <div className="grammar-flex-table">
        {[
          ['Collocation', 'Context'],
          ['Provide insights', 'Data analysis and metrics'],
          ['Provide a workaround', 'Fixing a bug or technical debt'],
          ['Provide documentation', 'Essential for maintainability'],
          ['Provide support', 'Long-term stability'],
        ].map(([collocation, context], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{collocation}</div>
            <div className="grammar-cell">{context}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProvideVerbExplanation;
